module.exports = __webpack_public_path__ + "static/media/github.66f00eae.svg";